/**
 * ASL Betriebsleiter Executive Hub - Telemetry Constants & Data Structures
 * Explicit Demo-Mode & Mock Data Structures (No unverified production truth).
 */

export const IS_DEMO_MODE = true;

export const TOTAL_SKU_COUNT = 1472;
export const TENANTS_COUNT = 4;
export const ACTIVE_TENANTS = ['ASL Ademco (Demo)', 'Alpha Schutzsysteme (Demo)', 'Beta Sicherheit (Demo)', 'Delta Alarm (Demo)'];

export const TOTAL_MASTER_DOCS = 1057;
export const TOTAL_PAGES = 21164;
export const TOTAL_CHUNKS = 28412;
export const TOTAL_SKU_LINKS = 10746;

export const NORMATIVE_PLANNING_ENGINES = [
  { code: 'DIN 14675', name: 'Brandmeldeanlagen (BMA)', scope: 'Phasen 6.1-6.4, Brandmelder-Projektierung, Akustik nach DIN 33404-3 (Konzept)' },
  { code: 'VdS 2311', name: 'Einbruchmeldeanlagen (EMA)', scope: 'Klassen A/B/C, Sicherungsbereiche, Bewegungsmelder & Dual-Melder (Konzept)' },
  { code: 'DIN EN 62676', name: 'Videoüberwachungsanlagen (VSS)', scope: 'Erkennen, Identifizieren, Beobachten (DORI-Kriterien, Konzept)' },
];

export const ALWIS_CORE_CAPABILITIES = [
  { code: 'Kompatibilität', name: 'Zubehör- & Systemberatung', scope: 'Assistent für Netzteile, Akkus, Erweiterungsmodule und Melder (Demo)' },
  { code: 'Sortiment', name: 'Katalog- & Produktsuche', scope: 'Strukturierte B2B-Artikelsuche und Alternativen (Demo)' },
  { code: 'Stücklisten', name: 'Projektzusammenstellung', scope: 'Zusammenstellung von Artikelsets für Anfragen (Demo)' },
];

export const SECURITY_COMPLIANCE = {
  zeroAudioRetention: true,
  ephemeralProcessing: true,
  retentionMs: 0,
  dsgvoCompliant: false,
  auditVerified: false,
  statusText: 'Architektur-Konzept (Audit ausstehend)',
  encryption: 'TLS 1.3 / AES-256-GCM',
  hostingLocation: 'Frankfurt / EU Data Boundary',
};

export const PRICE_CATALOG_SYNC = {
  timestamp: null,
  formattedDate: 'Demo-Modus (Nicht synchronisiert)',
  status: 'DEMO',
  totalSkus: 1472,
  unclassifiedItems: 0,
};

export const SYSTEM_HEALTH_MATRIX = [
  {
    id: 'd1',
    name: 'Cloudflare D1 SQL Datenbank',
    subsystem: 'Storefront & Control-Plane Storage',
    status: 'DEMO',
    latencyMs: 0,
    metrics: 'Musterdaten • Nicht live verbunden',
    description: 'Relationales Schema für Katalog-, Preis- und Mandantendaten (Vorschau).',
  },
  {
    id: 'vectorize',
    name: 'Cloudflare Vectorize BGE-M3',
    subsystem: 'Dense Vector Search Engine',
    status: 'DEMO',
    latencyMs: 0,
    metrics: 'Musterindex • Nicht live verbunden',
    description: 'Vektor-Datenbank für semantische Ähnlichkeitssuche (Vorschau).',
  },
  {
    id: 'ai-search',
    name: 'Cloudflare AI Search Pilot',
    subsystem: 'Hybrid RRF Ranking (Dense + FTS5 BM25)',
    status: 'DEMO',
    latencyMs: 0,
    metrics: 'Muster-Ranking • Nicht live verbunden',
    description: 'Hybrides Retrieval mit Normenextraktion (Vorschau).',
  },
  {
    id: 'voice-webrtc',
    name: 'ALWIS Voice WebRTC Copilot',
    subsystem: 'Voice Fachberater & Planer',
    status: 'DEMO',
    latencyMs: 0,
    metrics: 'Ephemeral RAM Konzept • Vorschau',
    description: 'Sprachassistent für BMA- und EMA-Projektierung (Vorschau).',
  },
  {
    id: 'tenant-isolation',
    name: 'Multi-Tenant Isolation Guard',
    subsystem: 'Tenant Partitioning & Access Control',
    status: 'DEMO',
    latencyMs: 0,
    metrics: 'Mandanten-Partitionierung (Vorschau)',
    description: 'Mandantenspezifische Trennung von Preisen und CI-Theming (Vorschau).',
  },
];

export const EXECUTIVE_KPIS = [
  {
    id: 'skus',
    title: 'Katalog-Artikel (Muster)',
    value: '1.472 SKUs (Demo)',
    change: 'Demo-Daten',
    trend: 'neutral',
    icon: 'Package',
    category: 'Shop',
    subtext: 'Exemplarischer B2B-Katalog (Demo-Modus)',
  },
  {
    id: 'tenants',
    title: 'Mandanten-Netzwerk (Muster)',
    value: '4 Mandanten (Demo)',
    change: 'Demo-Mandanten',
    trend: 'neutral',
    icon: 'Users',
    category: 'Multi-Tenant',
    subtext: 'Exemplarische Partner-Shops (Demo-Modus)',
  },
  {
    id: 'rag-corpus',
    title: 'RAG Wissenskorpus (Muster)',
    value: '1.057 Docs (Demo)',
    change: 'Demo-Korpus',
    trend: 'neutral',
    icon: 'BookOpen',
    category: 'RAG',
    subtext: 'Exemplarische Dokumentbasis (Demo-Modus)',
  },
  {
    id: 'compliance',
    title: 'Architektur & Datenschutz',
    value: 'Konzeptuell (Demo)',
    change: 'Audit ausstehend',
    trend: 'neutral',
    icon: 'ShieldCheck',
    category: 'Compliance',
    subtext: 'Geplante Normen- & DSGVO-Konformität (keine Live-Zertifizierung)',
  },
];

export const INITIAL_CHANGELOG_EVENTS = [
  {
    id: 'evt_001',
    timestamp: '2026-08-21T08:30:00Z',
    formattedDate: 'Demo-Vorschau',
    category: 'Shop',
    title: 'Katalog-Musterdaten geladen',
    description: 'Exemplarische B2B-Katalogdaten für die Benutzeroberflächen-Vorschau initialisiert.',
    status: 'demo',
    badge: 'Demo-Shop',
  },
  {
    id: 'evt_002',
    timestamp: '2026-08-21T07:45:00Z',
    formattedDate: 'Demo-Vorschau',
    category: 'RAG',
    title: 'RAG-Strukturmuster initialisiert',
    description: 'Exemplarische Vektor- und Dokumentstrukturen für die Vorschau vorbereitet.',
    status: 'demo',
    badge: 'Demo-RAG',
  },
  {
    id: 'evt_003',
    timestamp: '2026-08-21T06:15:00Z',
    formattedDate: 'Demo-Vorschau',
    category: 'ALWIS',
    title: 'Planungsregeln-Referenz hinterlegt',
    description: 'DIN 14675- und VdS 2311-Regelwerksreferenzen für Planungslogik hinterlegt.',
    status: 'demo',
    badge: 'Demo-Normen',
  },
  {
    id: 'evt_004',
    timestamp: '2026-08-20T18:00:00Z',
    formattedDate: 'Demo-Vorschau',
    category: 'Security',
    title: 'Datenschutzkonzept dokumentiert',
    description: 'Architekturkonzept für flüchtige Audioverarbeitung ohne Persistierung definiert.',
    status: 'demo',
    badge: 'Demo-Security',
  },
];

/** Startseite für Partner (Manges): nur der Partnerprogramm-Tab ist sichtbar. Für interne Nutzung auf false setzen. */
export const HUB_PARTNER_ONLY = true;

export const EXECUTIVE_TABS = [
  { id: 'overview', label: 'Übersicht', icon: 'LayoutDashboard', description: 'Gesamtstatus, KPIs und Plattform-Säulen (Demo-Modus)' },
  { id: 'partner', label: 'Partnerprogramm', icon: 'Handshake', description: 'Kundenstand, Abgleich und offene Fragen (Manges-Überblick)' },
  { id: 'shop', label: 'White-Label Shop', icon: 'Store', description: 'Musterkatalog & Mandanten-Vorschau' },
  { id: 'alwis', label: 'ALWIS Fachberater', icon: 'Bot', description: 'Normative Planung & BoM Transfer (Demo)' },
  { id: 'rag', label: 'RAG Wissensdatenbank', icon: 'BookOpen', description: 'Vektor-Index & Upload-Center (Demo)' },
  { id: 'changelog', label: 'Update-Feed', icon: 'Activity', description: 'Chronologische System- & Datenaktualisierungen' },
];
